import React, { useContext } from "react";
import { IApiService } from "../../../store/services";

export type IApiContext = {
  altiusApi: IApiService;
};

export const ApiContext = React.createContext<IApiContext>({} as IApiContext);
export const useApi = (): IApiContext => useContext<IApiContext>(ApiContext);
